/** Meta pixel "pixel bootcamp class ready" (stockdigital.com, connected to the stock 4 ad account).
 *  PageView on load, ViewContent when the offer section is seen, InitiateCheckout ONLY on the offer button. */
export const META_PIXEL_ID = '1650591249752408';
